export enum AssetType {
  Auto = 'Auto',
  C500 = 'C500',
  KiCall = 'KiCall',
  P500 = 'P500',
  T500 = 'T500',
  Tamo = 'Tamo',
  TamoA5 = 'TamoA5',
  TamoAir = 'TamoAir',
  TamoEU = 'TamoEU',
  TamoGo = 'TamoGo',
  TamoMax = 'TamoMax',
  TamoMini = 'TamoMini',
  TamoPro = 'TamoPro',
  TamoProEU = 'TamoProEU',
  Wolflok = 'Wolflok',
  WolflokGo = 'WolflokGo',
  WolflokMini = 'WolflokMini',
  WolflokPro = 'WolflokPro',
}

export enum FriendlyAssetType {
  Auto = 'Auto',
  C500 = 'C500',
  KiCall = 'KiCall',
  P500 = 'P500',
  T500 = 'T500',
  Tamo = 'Tamo',
  TamoA5 = 'Tamo A5',
  TamoAir = 'Tamo Air',
  TamoEU = 'Tamo EU',
  TamoGo = 'Tamo Go',
  TamoMax = 'Tamo Max',
  TamoMini = 'Tamo Mini',
  TamoPro = 'Tamo Pro',
  TamoProEU = 'Tamo Pro EU',
  Wolflok = 'Wolflok',
  WolflokGo = 'Wolflok Go',
  WolflokMini = 'Wolflok Mini',
  WolflokPro = 'Wolflok Pro',
  Unknown = 'Unknown'
}

export function getFriendlyAssetType(product: AssetType) {
  const friendNames = {
    [AssetType.Auto]: FriendlyAssetType.Auto,
    [AssetType.C500]: FriendlyAssetType.C500,
    [AssetType.KiCall]: FriendlyAssetType.KiCall,
    [AssetType.P500]: FriendlyAssetType.P500,
    [AssetType.T500]: FriendlyAssetType.T500,
    [AssetType.Tamo]: FriendlyAssetType.Tamo,
    [AssetType.TamoA5]: FriendlyAssetType.TamoA5,
    [AssetType.TamoAir]: FriendlyAssetType.TamoAir,
    [AssetType.TamoEU]: FriendlyAssetType.TamoEU,
    [AssetType.TamoGo]: FriendlyAssetType.TamoGo,
    [AssetType.TamoMax]: FriendlyAssetType.TamoMax,
    [AssetType.TamoMini]: FriendlyAssetType.TamoMini,
    [AssetType.TamoPro]: FriendlyAssetType.TamoPro,
    [AssetType.TamoProEU]: FriendlyAssetType.TamoProEU,
    [AssetType.Wolflok]: FriendlyAssetType.Wolflok,
    [AssetType.WolflokGo]: FriendlyAssetType.WolflokGo,
    [AssetType.WolflokMini]: FriendlyAssetType.WolflokMini,
    [AssetType.WolflokPro]: FriendlyAssetType.WolflokPro,
  }

  return friendNames[product] || FriendlyAssetType.Unknown
}